import React from 'react';
import { fmt, sum, isNum } from '../../utils/format.js';

const Score = ({ fixture }) => {
  if (fixture.home_points !== null && fixture.home_points !== undefined) {
    const ratings = fixture.ratings;
    // The old guard tested home_elo alone and then called .toFixed() on four
    // other fields, any one of which could be null. mov_mult in particular is
    // only written when a game has been rated.
    const hasFullRatings = ratings && [
      ratings.home_pre_elo, ratings.home_elo,
      ratings.away_pre_elo, ratings.away_elo, ratings.mov_mult,
    ].every(isNum);
    return (
      <div>
        {fixture.home_team} - {fixture.home_points} <br /> {fixture.away_team} -{' '}
        {fixture.away_points} <br />
        total - {fmt(sum(fixture.home_points, fixture.away_points), 0)}
        {hasFullRatings && (
          <div>
            <div>
              {fixture.home_team} - {fmt(ratings.home_pre_elo, 0)} ----{' '}
              {fmt(ratings.home_elo, 0)}
            </div>
            <div>
              {fixture.away_team} - {fmt(ratings.away_pre_elo, 0)} ----{' '}
              {fmt(ratings.away_elo, 0)}
            </div>
            <div>
              Margin of Victory: - {fmt(ratings.mov_mult, 2)}
            </div>
          </div>
        )}
      </div>
    );
  }
  return null;
};

export default Score;